<script>
export default {
  name: "CompanyEditForm",
  props: {
    // routePrefix: {
    //   type: String,
    //   default: "companies",
    // },
    companyGuid: String,
    company: Object,
    activityTypes: Array,
    // companyActivityType: String,
    // companyTitle: String,
    // companyDescription: String,
    // validateErrors: Array,
    // formRoute: String,
  },
  data() {
    return {
      selected: "",
    }
  },
  created() {
    if (this.companyActivityType) {
      this.selected = this.companyActivityType
    }
  },
  computed: {
    getActivityTypes() {
      return _.sortBy(_.filter(this.activityTypes, "View"), "Name")
    },
    getActivityTypesOptions() {
      return _.map(this.getActivityTypes, (item) => {
        return {value: item.Id, text: item.Name}
      })
    },
  },
  methods: {
    companyDelete(guid) {
      this.boxTwo = ""
      this.$bvModal
        .msgBoxConfirm("Действительно удалить компанию?", {
          title: "Подтверждение удаления компании",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Удалить",
          cancelTitle: "Отменить",
          hideHeaderClose: true,
          centered: true,
          bodyClass: "h5",
          titleClass: "font-weight-bold",
          headerClass: "border-bottom-0",
          footerClass: "border-top-0",
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            window.location = `/companies/${guid}/delete`
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
  },
}
</script>
